import {NgModule} from '@angular/core';
import {ProductCardComponent} from './product-card.component';
import {SharedModule} from "../../../shared.module";
import {ProductCardCarouselComponent} from "./carousel/product-card-carousel.component";
import {CarouselModule} from "ngx-bootstrap/carousel";

@NgModule({
    imports: [SharedModule, CarouselModule],
    declarations: [ProductCardComponent, ProductCardCarouselComponent],
    exports: [ProductCardComponent, ProductCardCarouselComponent]
})
export class ProductCardModule {
}
